<template>
  <div class="failed_booking">
    <h5>New Customer Funnel ({{ new_customers.length }})</h5>
    <div class="card-deck scrolling-wrapper my-3 co-md-12">
      <div
        class="card col-2 p-2 row show_hand news"
        v-bind:class="{ active_card: status == 0 }"
        v-on:click="changestatus(0)"
      >
        <div class="col-md-8 m-0 p-0 pt-2 text-left">
          <div @drop="openModalbydrag(0, 'New')" class="drop d-flex">
            <h6>
              <span v-if="loading && limited.length == 0">Loading..</span>
              <span v-else>{{ new_cx_count.new }}</span>
              New.
            </h6>
          </div>
        </div>
        <div class="wrapper-progress text-center">
          <div class="progress" v-bind:style="{ width: newCount + '%' }">
            <span class="percent-progress">{{ newCount }}%</span>
          </div>
        </div>
      </div>
      <div
        class="card col-2 p-2 show_hand row"
        v-bind:class="{ active_card: status == 1 }"
        v-on:click="changestatus(1)"
      >
        <div class="col-md-8 m-0 p-0 pt-2 text-left">
          <div @drop="openModalbydrag(1, 'Postponed')" class="drop d-flex">
            <h6>
              <span v-if="loading && limited.length == 0">Loading..</span>
              <span v-else>{{ new_cx_count.postponed }}</span>
              Postponed.
            </h6>
          </div>
        </div>
        <div class="wrapper-progress text-center">
          <div class="progress" v-bind:style="{ width: postponedCount + '%' }">
            <span class="percent-progress">{{ postponedCount }}%</span>
          </div>
        </div>
      </div>
      
      <div
        class="card col-2 p-2 row show_hand"
        v-bind:class="{ active_card: status == 4 }"
        v-on:click="changestatus(4)"
      >
        <div class="col-md-8 m-0 p-0 pt-2 text-left">
          <div @drop="openModalbydrag(4, 'Closed')" class="drop d-flex">
            <h6>
              <span v-if="loading && limited.length == 0">Loading..</span>
              <span v-else>{{ new_cx_count.successful }}</span>
              Successful.
            </h6>
          </div>
        </div>
        <div class="wrapper-progress text-center">
          <div class="progress" v-bind:style="{ width: sucessCount + '%' }">
            <span class="percent-progress">{{ sucessCount }}%</span>
          </div>
        </div>
      </div>

    </div>
    <div
      class="col-md-12 m-0 mb-3 p-0 d-flex justify-content-between filtering"
    >
    
      <div class="filter m-0 p-0 d-flex">
        <!-- <label class="mt-2" for="sortby px-3">Model:</label> -->
        <input
          type="text"
          v-model="search"
          placeholder="search.."
          class="form-control p-1 pl-0 mr-2 ml-0"
        />
      </div>
      <div class="filter m-0 p-0 d-flex">
        <label class="mt-2" for="sortby px-3">Limit:</label>
        <select v-model="limit" class="form-control p-1 mr-2">
          <option :value="new_customers.length">Load All</option>
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="30">30</option>
          <option value="40">40</option>
        </select>
      </div>
      <!-- <div class="date_picker d-flex pr-3">
           <label class="mt-2 ml-2" for="datefrom">Start: </label><input v-model="fromDate" type="date" class="form-control mx-2">
           <label class="mt-2 ml-2" for="dateTo">End:</label><input type="date" class="form-control mx-2" v-model="toDate">
           <input type="button" class="button-on form-control ml-2 mr-0" value="Fetch">
     </div> -->
      <div class="text-right m-0 p-0">
        <label for="" class="pt-2 pr-3"
          >Data as on:
          <strong> {{ asOnDate | moment("MMMM Do YYYY") }}</strong>
        </label>
      </div>
      <div>
        <!-- <select class="form-control" @change="loadData(datesValue)" v-model="datesValue" name="" id="">
         <option value="1">TODAY</option>
         <option value="2">YESTERDAY</option>
         </select> -->
        <input
          type="date"
          class="form-control"
          @change="loadData(datesValue)"
          v-model="datesValue"
        />
      </div>
    </div>
    <div class="col-md-12 m-0 p-0">
      <p class="percentage" v-if="model_selected">
        Total {{ drop_vehicle.length }} <strong>{{ model_selected }}</strong
        >, {{ Percentage_total }}% of Total Funnel &
        <span v-if="status === 0">{{ percentage_new }}% of New.</span>
        <span v-if="status === 1">{{ percentage_postponed }}% Postponed</span>
        <span v-if="status === 2"
          >{{ percentage_underAction }}% Under Action</span
        >
        <span v-if="status === 3"
          >{{ percentage_not_interested }}% Not Interested</span
        >
        <span v-if="status === 4">{{ percentage_success }}% Successful</span>
      </p>
    </div>

    <div
      v-if="selectedCustomer.length > 0"
      class="col-md-12 d-flex justify-content-between m-0 p-0 p-2"
      style="border:1px solid red"
    >
      <p class="m-0 p-0 pt-2">{{ selectedCustomer.length }} items selected.</p>
      <div class="btn-group dropleft">
        <button
          type="button"
          class="btn dropdown-toggle m-0 p-1"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          Take Action
        </button>
        <div class="dropdown-menu">
          <a
            class="dropdown-item"
            v-on:click="sendSmsModal=!sendSmsModal"
            >Send Bulk Message</a
          >
          <a class="dropdown-item" @click="alert()" disabled>Send Notification</a>
        </div>
      </div>
    </div>
    <div class="table-responsive text-left">
      <table class="table">
        <thead>
          <tr>
            <!-- <th><i class="fa fa-arrows" aria-hidden="true"></i></th> -->
            <!-- <th scope="col">ID</th> -->
            <th class="m-0 p-0 pl-1 pb-2" style="col m-0 p-0">
              <input v-model="selectAll" type="checkbox" />
            </th>
            <th style="white-space: nowrap;" scope="col">ID</th>
            <th scope="col">Name</th>
            <th scope="col">Email</th>
            <th scope="col">Phone</th>
            <!-- <th scope="col">Vehicle</th> -->
            <th scope="col">Date</th>
            <th scope="col">Status</th>
            <th scope="col">SMS</th>
            <!-- <th>Squad</th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="(data, index) in failed_booking_filtered" :key="index">
            <!-- <drag @drag="setid(data)"  class="drag"><td><i class="fa fa-arrows" aria-hidden="true"></i></td></drag> -->
            <!-- <td>{{data.id}}</td> -->
            <td>
              <input
                v-model="selectedCustomer"
                :value="data.mobile"
                type="checkbox"
              />
            </td>
            <td v-b-tooltip.hover :title="data.comment || 'Change status to see comments'" class="hand">
              {{ data.id }}
            </td>
            <td v-b-tooltip.hover :title="'Click to view profile of '+data.fName" class="link" @click="openProfile(data.id, data.mobile)">
              {{ data.fName }} {{ data.lName }}
            </td>
            <td>{{ data.email }}</td>
            <td>
              <span class="badge badge-secondary zoom">
                <a
                  style="text-decoration:none;color:white"
                  :href="'tel:' + data.mobile"
                  >{{ data.mobile }}
                </a>
              </span>
              <span class="pl-1" v-if="data.mobileVerified == 1"
                ><img src="src/assets/check.svg" width="10px"
              /></span>
            </td>
            <td style="white-space: nowrap;">
              {{ data.createdAt | moment("from", "now") }}
            </td>
            <td v-b-tooltip.hover title="Change status">
              <div class="btn-group dropleft">
                <button
                  id="tooltip2"
                  type="button"
                  class="btn dropdown-toggle m-0 p-1"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Change Status
                  <span v-if="data.flag === 0">Current Status New</span>
                  <span v-if="data.flag === 1">Current Status Postponed</span>
                  <span v-if="data.flag === 2"
                    >Current Status Under Action</span
                  >
                  <span v-if="data.flag === 3"
                    >Current Status Not Interested</span
                  >
                  <span v-if="data.flag === 4">Current Status Successful</span>
                </button>
                <div class="dropdown-menu">
                  <a
                    class="dropdown-item"
                    v-on:click="openModal(data.id, 0, 'New', data.comment)"
                    >Flag New</a
                  >
                  <a
                    class="dropdown-item"
                    v-on:click="openModal(data.id, 1, 'Postpond', data.comment)"
                    >Postpone</a
                  >

                  <!--
              <a class="dropdown-item" v-on:click="openModal(data.id, 2, 'Action Taken', data.comment)">Flag Under Action</a>
              <a class="dropdown-item" v-on:click="openModal(data.id, 3, 'Not Interested', data.comment)">Flag Not Interested</a>
              -->
                  <a
                    class="dropdown-item"
                    v-on:click="
                      openModal(data.id, 4, 'Successful', data.comment)
                    "
                    >Flag Successful</a
                  >
                  <a
                    class="dropdown-item"
                    v-on:click="opensmsModal(data.id, data.mobile)"
                    >Send SMS</a
                  >
                </div>
              </div>
            </td>

            <td class="hand text-center">
              <i
                v-b-tooltip.hover title="Send Custom Message"
                v-on:click="opensmsModal(data.id, data.mobile)"
                class="fa fa-envelope pt-2"
                aria-hidden="true"
              ></i>
              <i
                v-b-tooltip.hover title="Send Custom Notification"
                v-on:click="sendPromition(data.id, data.mobile)"
                class="fa fa-bell pt-2 ml-3"
                aria-hidden="true"
              >
              </i>
            </td>
            <td>
              <!-- <button @click="createLead(data)">SV</button> -->
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="loading && new_customers.length == 0" class="mt-5 text-center">
        <img src="src/assets/ontrackloader.gif" width="50px" alt="" />
        <p><span class="highlight">Hold up tight.</span></p>
        <p><span class="highlight">Your data is being loaded.</span></p>
      </div>

      <div
        v-if="!loading && new_customers.length == 0"
        class="mt-5 text-center"
      >
        <img src="src/assets/ok.svg" width="50px" alt="" />
        <p>
          <span class="highlight"
            >woooahhhh we have a clear new customer funnel..</span
          >
        </p>
        <p><span class="highlight">Great!!!!</span></p>
      </div>
    </div>


    <div
      id="mymodals"
      class="modals"
      v-bind:class="{ displayModal: sendSmsModal }"
    >
      <!-- modals content -->
      <div class="modals-content p-0 mt-5">
        <div class="modal-heading m-0 p-2 px-3 d-flex justify-content-between" style="background:#7977c2;color:white">
            <p class="m-0 p-0"><strong>Send Sms</strong></p>
            <p v-on:click="sendSmsModal=!sendSmsModal">X</p>
        </div>
        <div class="col-md-12 p-2">
          <textarea name="" v-model="messageBody" placeholder="please type your message" id="" class="form-control" rows="10"></textarea>
        </div>
        <div class="col-md-12 mb-2 text-right">
          <button class="ontrack-button" @click="sendSms">Send</button>
        </div>
      </div>
    </div>

    <b-modal
      v-model="showModal"
      :title="'Hey ' + username + ', sure changing status to ' + action + ' ?'"
      hide-footer
      scrollable
    >
      <!-- modals content -->
      <div class="">
        <!-- <div class="modal-heading m-0 p-3 d-flex justify-content-between">
          <h6 class="m-0 p-0">
            
          </h6>
          <img
            v-on:click="closeModal"
            class="hand m-0 p-0"
            src="src/assets/close.svg"
            width="15px"
            alt=""
          />
        </div> -->
        <div
          class="col-md-12 m-0 p-3 pt-0 mb-3 previousComment"
          v-if="commentData.length > 0"
        >
          <p class="m-0 p-0 py-2">Previous Comments:</p>
          <div
            class="card col-md-8 p-2 mb-2"
            v-for="(data, index) in commentData"
            :key="index"
          >
            <p class="comment p-0 m-0">{{ data.comment }}</p>
            <div class="discription d-flex justify-content-between">
              <p class="p-0 m-0 label">
                {{ data.createdAt | moment("from", "now") }}
              </p>
              <p class="p-0 m-0 label">{{ data.userName }}</p>
            </div>
          </div>
        </div>
        <div class="text-center no-comments col-md-12" v-else>
          <img src="src/assets/no.svg" width="100px" class="my-3" />
          <p>No comments yet.</p>
        </div>
        <div class="col-md-12" v-if="status_to_change == 1">
          <div class="col-md-12 my-4 m-0 p-0">
            <div>
              <b-form-checkbox v-model="remind" name="check-button" switch>
               Remind me for this.
              </b-form-checkbox>
            </div>
          </div>
          <div class="col-md-12 my-4 m-0 p-0">
            <label class="label" v-if="takeDate" for="calender"
              >When to remind you?
              <input
                id="calender"
                class="form-control mt-2"
                type="date"
                v-if="takeDate"
                v-model="reminder_date"
              />
            </label>
          </div>
        </div>
        <div class="col-md-12">
          <p class="label">Add a comment</p>
          <b-form-textarea
            v-model="comment"
            style=""
            placeholder="eg: customer has changed his mind."
          ></b-form-textarea>
        </div>
        <div class="col-md-12 my-4">
          <div class="colmd-12 text-right mb-4">
            <button :disabled="!comment" v-on:click="change_status()" class="ontrack-button">
              <span v-if="changing">Wait...</span>
              <span v-else>I'm, Sure!</span>
            </button>
          </div>
          <b-alert :show="!comment">
            <p style="color:red">
              <i class="fal fa-exclamation"></i>
              Comment is mandatory!</p>
            For those status changed without proper comment will be considered fatal. Please ensure to leave a commet on every status you change.
          </b-alert>
        </div>
      </div>
    </b-modal>

    <div
      id="mymodals"
      class="modals"
      v-bind:class="{ displayModal: showsmsModal }"
    >
      <!-- modals content -->
      <div class="modals-content mt-5">
        Sending sms to
        <input
          type="text"
          ref="typeBox"
          class="phone_input"
          v-bind="{ show_edit: showEdit }"
          v-model="send_sms_mobile"
        />
        <i
          class="fa fa-pencil size_12 hand"
          v-on:click="editMobile"
          aria-hidden="true"
        ></i>
        <span class="close" v-on:click="closeSmsModal">&times;</span>
        <div class="col-md-12 my-3 m-0 p-0 previous">
          <div
            class="card border col-md-8 p-2 mb-2"
            v-for="(data, index) in message_sent"
            :key="index"
          >
            <p class="sms p-0 m-0">{{ data.sms }}</p>
            <div class="discription d-flex justify-content-between">
              <p class="p-0 m-0">
                {{ data.createdAt | moment("from", "now") }}
              </p>
              <p class="p-0 m-0">{{ data.agent }}</p>
            </div>
          </div>
          <div class="loading text-center my-5" v-if="loadingChat">
            <div class="spinner-grow text-primary" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-secondary" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-success" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <p>Loading Chat History</p>
          </div>
          <div
            class="initiate text-center my-5"
            v-if="!loadingChat && message_sent.length == 0"
          >
            <i class="fa fa-commenting-o" aria-hidden="true"></i>
            <p>We haven't sent any SMS to the customer.</p>
            <p class="m-0 p-0">
              Start Sending now
              <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
            </p>
          </div>
        </div>
        <div class="">
          <textarea
            type="text"
            v-model="sms"
            placeholder="type message.."
            class="text-area form-control"
          ></textarea>
        </div>
        <div class="modal-footer uk-clearfix">
          <button v-on:click="sendMessage()" class="ontrack-button">
            <span v-if="sendingsms">Sending.....</span>
            <span v-else>Send Message</span>
          </button>
        </div>
      </div>
    </div>
    <b-modal hide-footer ref="send-sms" scrollable  id="send-sms" size="xl" title="Send SMS to Customer">
      <sms :metaData="sendSmsMetaData" :id="send_sms_id"></sms>
    </b-modal>
  </div>
</template>
<script>
const axios = require("axios");
const moment = require("moment");
import * as _ from "lodash";
// const moment = require('moment')
export default {
  data() {
    return {
      sendSmsMetaData: '',
      messageBody:'',
      status: 0,
      showModal: false,
      action: "",
      comment: "",
      edit_id: "",
      comment_previous: "",
      status_to_change: "",
      model_selected: "",
      fromDate: null,
      toDate: null,
      showsmsModal: false,
      sms: "",
      send_sms_id: "",
      send_sms_mobile: "",
      sendingsms: false,
      message_sent: "",
      loadingChat: true,
      showEdit: false,
      changing: false,
      remind: "",
      reminder_date: "",
      search: "",
      limit: 10,
      datesValue: 1,
      asOnDate: "",
      loadingComments: true,
      commentData: [],
      sendSmsModal:false,
      selectedCustomer: [],
      selectAll: false,
    };
  },
  watch: {
    selectAll() {
      if (this.selectAll) {
        this.failed_booking_filtered.forEach((x) => {
          this.selectedCustomer.push(x.mobile);
        });
      } else {
        this.selectedCustomer = [];
      }
    },
  },
  created() {
    let agent_id = localStorage.getItem("agent_id");
    if (!agent_id && !this.username) {
      this.$router.push("/login");
    }
    this.$store.dispatch("get_new_customers", { date: this.date });
    this.asOnDate = this.date;
    this.$store.dispatch("get_models");

    // const x = this.$route.query.id
    // if(x){
    // this.status = 1
    // this.search = x
    // }else{
    //   return
    // }
  },
  methods: {

    // openSendSms(phone){
    //   axios
    //     .get(
    //       "https://glacier.on-track.in/api/sms/send-sms-bulk",
    //       {
    //         phones: this.selectedCustomer,
    //         smsBody: this.messageBody,
    //         agentId: this.username,
    //         agentName: this.agent_id,
    //       },
    //       {
    //         headers: {
    //           "Content-Type": "application/json",
    //           Authorization: "Bearer UuEkCLwr5dfkkAtflkRyMSG0YE8CWD",
    //         },
    //       }
    //     )
    //     .then(() => {
    //           this.$toasted.show("Send Sucessfully!", {
    //             type: "success",
    //             position: "bottom-center",
    //             duration: 1000,
    //             theme: "bubble",
    //           });
    //           this.sendSmsModal = false
    //     })
    //     .catch(() => {
    //       this.$toasted.show("Some error occured!", {
    //         type: "error",
    //         position: "bottom-center",
    //         duration: 1000,
    //         theme: "bubble",
    //       });
    //       this.loadData(this.datesValue);
    //     });
    // },


    sendSms(){
      axios
        .post(
          "https://glacier.on-track.in/api/sms/send-sms-bulk",
          {
            phones: this.selectedCustomer,
            smsBody: this.messageBody,
            agentId: Number(this.agent_id),
            agentName: this.username,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer UuEkCLwr5dfkkAtflkRyMSG0YE8CWD",
            },
          }
        )
        .then(() => {
              this.$toasted.show("Send Sucessfully!", {
                type: "success",
                position: "bottom-center",
                duration: 1000,
                theme: "bubble",
              });
              this.sendSmsModal = false
        })
        .catch(() => {
          this.$toasted.show("Some error occured!", {
            type: "error",
            position: "bottom-center",
            duration: 1000,
            theme: "bubble",
          });
          this.loadData(this.datesValue);
        });
    },
    alert(){
      this.$toasted.show("Coming Soon!", {
            type: "error",
            position: "bottom-center",
            duration: 1000,
            theme: "bubble",
          });
    },
    openProfile(id, mobile) {
      this.$router.push({ path: "/userProfile/" + id + "/" + mobile });
    },
    loadData(date) {
      if (date == 1) {
        this.asOnDate = this.date;
        this.$store.dispatch("get_new_customers", { date: this.date });
      } else if (date == 2) {
        this.asOnDate = this.yesterday;
        this.$store.dispatch("get_new_customers", { date: this.yesterday });
      } else {
        this.$store.dispatch("get_new_customers", { date: this.datesValue });
      }
    },

    createLead(data) {
      axios
        .post(
          "https://corsanywhere.herokuapp.com/https://app.squadrun.co/api/v4/leads/create/KJLHY1/",
          {
            lead_id: data.id,
            phone_number: data.mobile,
            contact_name: data.fName + " " + data.lName,
            lead_source: "WEB",
            lead_email: data.email,
            waitlist_date: "null",
            vehicle_type: "NA",
            unique_payment_link: "NA",
            waitlist_vehicle: "null",
            registration_date: data.createdAt,
            status: 0,
            additional_notes: "Registration but not booked!",
            sv_outcome: "NA",
            not_interested_reason: "NA",
            judged_time: "NA",
            sv_lead_create_date: "NA",
            website_link: "book.on-track.in",
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer UuEkCLwr5dfkkAtflkRyMSG0YE8CWD",
            },
          }
        )
        .then(() => {
          axios
            .post(
              "https://api.on-track.in/api/updateCustomer",
              {
                flag: 5,
                id: data.id,
              },
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
                },
              }
            )
            .then(() => {
              this.sendSquadModel = false;
              this.$toasted.show("Done!", {
                type: "success",
                position: "bottom-center",
                duration: 1000,
                theme: "bubble",
              });
              this.loadData(this.datesValue);
            });
        })
        .catch(() => {
          this.$toasted.show("Some error occured!", {
            type: "error",
            position: "bottom-center",
            duration: 1000,
            theme: "bubble",
          });
          this.loadData(this.datesValue);
        });
    },
    checkModel(word, sentence) {
      let sent = sentence;
      let first_word = [];
      first_word = sent.split(" ", 2);
      if (first_word[0] === word) {
        return true;
      } else {
        return false;
      }
    },
    editMobile() {
      this.$refs.typeBox.focus();
    },
    changestatus(id) {
      this.status = id;
    },
    closeModal() {
      this.showModal = false;
      (this.comment_previous = ""), (this.comment = ""), (this.edit_id = "");
    },
    closeSmsModal() {
      this.send_sms_id = "";
      this.send_sms_mobile = "";
      this.sms = "";
      this.showsmsModal = false;
      this.loadingChat = true;
    },
    openModal(id, status, name, comment) {
      this.loadingComments = true;
      window.console.log(id);
      axios
        .post(
          "https://api.on-track.in/api/getAgentCommentData",
          {
            bookingId: id,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          }
        )
        .then((res) => {
          this.commentData = res.data;
          this.loadingComments = false;
          this.edit_id = id;
          this.status_to_change = status;
          this.action = name;
          this.comment_previous = comment;
          this.showModal = true;
        })
        .catch(() => {
          this.$toasted.global.my_app_error();
          this.loadingComments = false;
        });
    },
    opensmsModal(id, mobile) {
      // this.fetchMessages(id);
      // this.send_sms_id = id;
      // this.send_sms_mobile = mobile;
      // this.showsmsModal = true;
      this.send_sms_id = id;
                  var obj = {
                  mobile: mobile,
      }
      this.sendSmsMetaData = obj
      this.$refs['send-sms'].show()
    },
    sendPromition(id, mobile) {
      this.$router.push({
        path: "/sendNotification",
        query: { mobile: mobile, id: id },
      });
    },
    openModalbydrag(status, name, comment) {
      this.action = name;
      this.comment = comment;
      this.showModal = true;
    },
    handleDrop(data) {
      alert("yeahh" + data);
    },
    setid(data) {
      this.comment = data.comment;
      this.edit_id = data.id;
      window.console.log(this.comment);
    },
    change_status() {
      this.changing = true;
      axios
        .post(
          "https://api.on-track.in/api/addToAgentComment",
          {
            bookingId: this.edit_id,
            agentId: this.agent_id,
            comment: this.comment,
            current_flag: this.status_to_change,
            current_status: this.status_computed,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          }
        )
        .then(() => {
          axios
            .post(
              "https://api.on-track.in/api/updateCustomer",
              {
                flag: this.status_to_change,
                id: this.edit_id,
              },
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
                },
              }
            )
            .then(() => {
              this.changing = false;
              this.$toasted.show("Done!", {
                type: "success",
                position: "bottom-center",
                duration: 1000,
                theme: "bubble",
              });
              this.loadData(this.datesValue);
              this.showModal = false;
              this.comment = "";
            })
            .catch((x) => {
              alert(x);
              this.changing = false;
              this.$toasted.show("Some error occured!", {
                type: "error",
                position: "bottom-center",
                duration: 1000,
                theme: "bubble",
              });
              this.loadData(this.datesValue);
              this.showModal = false;
            });
        })
        .catch((err) => {
          this.message = err.msg;
          this.$toasted.global.my_app_error();
          this.changing = false;
        });
    },
    sendMessage() {
      this.sendingsms = true;
      axios
        .post(
          "https://api.on-track.in/api/sendSms",
          {
            mobile: this.send_sms_mobile,
            msg: this.sms,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          }
        )
        .then(() => {
          window.db
            .collection("sent_sms")
            .add({
              id: this.send_sms_id,
              mobile: this.send_sms_mobile,
              createdAt: new Date().toString("hh:mm tt"),
              agent: this.username,
              agent_id: this.agent_id,
              sms: this.sms,
            })
            .then(() => {
              // this.scrollToBottom()
              this.sendingsms = false;
              // console.log("Document written with ID: ", docRef.id);
              this.send_sms_id = "";
              this.send_sms_mobile = "";
              this.sms = "";
              this.showsmsModal = false;
              // this.message=''
            })
            .catch(function(error) {
              this.sendingsms = false;
              console.error("Error adding document: ", error);
              this.message = "";
              alert("something is wrong");
            });
        })
        .catch(() => {
          this.sendingsms = false;
          alert("something is wrong");
        });
    },
    fetchMessages(id) {
      window.db
        .collection("sent_sms")
        .where("id", "==", id)
        .onSnapshot((querySnapshot) => {
          let allMessages = [];
          querySnapshot.forEach((doc) => {
            allMessages.push(doc.data());
          });
          this.message_sent = allMessages;
          this.loadingChat = false;
        });
    },
  },
  computed: {
    takeDate() {
      if (this.remind == true) {
        return true;
      } else {
        return false;
      }
    },
    agent_id() {
      return localStorage.getItem("agent_id");
    },
    username() {
      return localStorage.getItem("username");
    },
    loading() {
      return this.$store.state.makingAJAX;
    },
    new_customers() {
      return this.$store.getters.newCustomerdata(this.status_computed);
    },
    limited() {
      return this.new_customers.slice(0, this.limit);
    },
    filteredList() {
      return this.limited;
      //   .filter(post => {
      //   return (post.customerName.toLowerCase().includes(this.search.toLowerCase())
      //   ||
      //   post.bookingId.toString().includes(this.search.toLowerCase())
      //   ||
      //   post.customerMobile.toString().includes(this.search.toLowerCase())
      //   )
      //   })
    },
    // test(){
    //        return this.$store.getters.demo
    // },
    filteredbydates() {
      var vm = this;
      var start = vm.fromDate;
      var end = vm.toDate;
      return _.filter(this.filteredList, function(data) {
        if (_.isNull(start) && _.isNull(end)) {
          return true;
        } else {
          var date = moment(data.createdAt).format("YYYY-MM-DD");
          return date >= start && date <= end;
        }
      });
    },
    failed_booking_filtered() {
      if (this.model_selected === "") {
        return this.filteredbydates;
      } else {
        return this.filteredbydates.filter((data) => {
          return data.modelName === this.model_selected;
        });
      }
    },
    models() {
      return this.$store.state.models_list;
    },
    status_computed() {
      return this.status;
    },
    new_cx_count() {
      return this.$store.getters.new_cx_count;
    },
    totalCount() {
      return (
        this.new_cx_count.new +
        this.new_cx_count.postponed +
        this.new_cx_count.successful
      );
    },
    newCount() {
      return Math.round((this.new_cx_count.new / this.totalCount) * 100) || 0;
    },
    postponedCount() {
      return (
        Math.round((this.new_cx_count.postponed / this.totalCount) * 100) || 0
      );
    },
    action_takenCount() {
      return (
        Math.round((this.new_cx_count.action_taken / this.totalCount) * 100) ||
        0
      );
    },
    notInterestedCount() {
      return (
        Math.round(
          (this.new_cx_count.not_interested / this.totalCount) * 100
        ) || 0
      );
    },
    sucessCount() {
      return (
        Math.round((this.new_cx_count.successful / this.totalCount) * 100) || 0
      );
    },
    comments_all() {
      return (
        `${this.comment}-${this.username} at ${this.date}` +
        "~~" +
        this.comment_previous
      );
    },
    date() {
      var date = new Date();
      var month = date.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      var day = date.getDate();
      var year = date.getFullYear();
      if (day < 10) {
        return year + "-" + month + "-" + "0" + day;
      } else {
        return year + "-" + month + "-" + day;
      }
    },
    yesterday() {
      var date = new Date();
      var month = date.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      var day = date.getDate() - 1;
      var year = date.getFullYear();
      return year + "-" + month + "-" + day;
    },
    today() {
      var date = new Date();
      var month = date.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      var day = date.getDate() - 1;
      var year = date.getFullYear();
      return year + "-" + month + "-" + day;
    },
    Percentage_total() {
      return (
        Math.round(
          (this.failed_booking_filtered.length / this.totalCount) * 100
        ) || 0
      );
    },
    percentage_new() {
      return (
        Math.round(
          (this.failed_booking_filtered.length / this.new_cx_count.new) * 100
        ) || 0
      );
    },
    percentage_postponed() {
      return (
        Math.round(
          (this.failed_booking_filtered.length / this.new_cx_count.postponed) *
            100
        ) || 0
      );
    },
    percentage_underAction() {
      return (
        Math.round(
          (this.failed_booking_filtered.length /
            this.new_cx_count.action_taken) *
            100
        ) || 0
      );
    },
    percentage_not_interested() {
      return (
        Math.round(
          (this.failed_booking_filtered.length /
            this.new_cx_count.not_interested) *
            100
        ) || 0
      );
    },
    percentage_success() {
      return (
        Math.round(
          (this.failed_booking_filtered.length / this.new_cx_count.successful) *
            100
        ) || 0
      );
    },
    width() {
      return window.innerHeight;
    },
  },
};
</script>
<style scoped>
.link:hover {
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}
.table-responsive::-webkit-scrollbar {
  width: 6px;
  background-color: #f5f5f5;
}
@media only screen and (max-width: 600px) {
  .scrolling-wrapper {
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
  }
  .scrolling-wrapper::-webkit-scrollbar {
    display: none;
  }
  .scrolling-wrapper .card {
    display: inline-block;
    margin: 0 5px;
  }

}

.filtering label {
  font-size: 15px;
}
.dropdown-menu {
  font-size: 12px;
}
.table .dropdown-toggle {
  font-size: 13px !important;
}
.show_hand {
  cursor: pointer;
  text-align: center;
  box-shadow: 0 1px 3px rgba(36, 39, 44, 0.15);
}
.table {
  min-height: 200px;
  text-align: left;
}
.table td {
  padding: 5px;
}
.modal-header {
  font-size: 20px;
}
.active_card {
  border-top: 5px solid rgb(244, 128, 36);
  background-color: rgb(244, 128, 36, 0.2);
  /* color: white;      */
}
.active_card .wrapper-progress {
  color: black;
}
.active_card .progress {
  background-color: rgb(244, 128, 36);
}
.dropdown-item {
  cursor: pointer;
}
.percentage {
  font-size: 13px;
}
.modals {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 999999; /* Sit on top */
  padding-top: 10px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}
.displayModal {
  display: block !important;
}
/* modals Content */
.modals-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 50%;
}
@media only screen and (max-width: 600px) {
  .modals-content {
    background-color: #fefefe;
    margin: auto;
    padding: 20px;
    border: 1px solid #888;
    width: 95%;
    font-size: 15px;
  }

  .news {
    margin-left: 0 !important;
  }
  .filtering {
    display: block !important;
  }
  .date_picker {
    display: block !important;
  }
  .button-on {
    margin-top: 10px;
  }
}
/* The Close Button */
.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
.drag {
  cursor: move;
}
.new {
  background-color: #e74c3c;
}
.postponed {
  background-color: #e67e22;
}
.action_taken {
  background-color: #1abc9c;
}
.under_action {
  background-color: #9b59b6;
}
.success {
  background-color: #2ecc71;
}
/* .progress {
    display: -ms-flexbox;
    display: flex;
    height: auto;
    width: inherit;
    overflow: hidden;
    font-size: .75rem;
    background-color: #e9ecef;
    border-radius: .25rem;
    text-align: center
}
.progress-bar {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: column;
    flex-direction: column;
    -ms-flex-pack: center;
    justify-content: center;
      overflow: visible;
    color: black;
    text-align: center;
    font-size: 10px;
    white-space: nowrap;
    transition: width .6s ease;
} */
.previousComment {
  max-height: 250px;
  min-height:250px;
  position: relative;
  overflow-y: scroll;
  background-color: whitesmoke;
}
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  display: none;
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: rgb(244, 128, 36, 0.8);
  border-radius: 1px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgb(244, 128, 36);
}
.previous .lead {
  color: red;
  font-size: 12px;
}
.previous {
  font-size: 17px;
}
.ontrack-button {
  border: none;
  padding: 5px;
  background-color: #7977c2;
  color: white;
  width: 35%;
  font-size: 16px;
}
.ontrack-button:hover {
  background-color: rgb(69, 67, 143);
}
.hand {
  cursor: pointer;
}
#tooltip1 {
  position: relative;
}
#tooltip1 span {
  display: none;
  color: #000000;
}
#tooltip1:hover span {
  display: block;
  position: absolute;
  width: 300px;
  height: auto;
  left: 95px;
  font-size: 11px;
  border-radius: 5px;
  top: -10px;
  color: #000000;
  padding: 0 5px;
  background-color: wheat;
  cursor: pointer;
}
#tooltip2 {
  position: relative;
}
#tooltip2 span {
  display: none;
  color: #000000;
}
#tooltip2:hover span {
  display: block;
  position: absolute;
  width: 100%;
  height: auto;
  right: 30px;
  border-radius: 5px;
  font-size: 11px;
  top: -20px;
  color: #000000;
  padding: 0 5px;
}
.phone_input {
  border: none;
  padding: 0px !important;
  width: 120px;
}
.size_12 {
  font-size: 12px;
}
.show_edit {
  border: 1px solid black !important;
}
.percent-progress {
  position: absolute;
}
</style>
